export default __webpack_public_path__ + "static/media/main-image.0fc4a66c.jpg";